module.exports = __webpack_public_path__ + "img/jf-logo.4eb542b7.png";